import {accessibilitySoundsEn} from "./en/en";
import {accessibilitySoundsDe} from "./de/de";

export function getSoundByKey(key: string, language: string): string {
    if(language != 'de' && language != 'de') {
        language = 'en';
    }

    const sounds = language == 'en' ? accessibilitySoundsEn : accessibilitySoundsDe;
    const sound = (sounds as any)[key];
    if(sound) {
        return sound;
    }
    throw new Error(`Cannot find sound for key ${key} and language ${language}`);
}